import type { Board } from '@trello/model-types';

export const allowsSelfJoin = (board: {
  prefs?: Pick<Partial<Board['prefs']>, 'isTemplate' | 'selfJoin'> | null;
}) => {
  return (board.prefs?.selfJoin ?? false) && !board.prefs?.isTemplate;
};
